import React from 'react'

function NotFoundPage() {
    return (
        <div>404 page not found</div>
    )
}

export default NotFoundPage